export enum UsageType {
    //default null
    NULL_VALUE="",
    //original values 
    ACTIVE = "ACTIVE",
    PREDICTED = "PREDICTED",
    TARGET = "TARGET"
}